module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-f0666e191f9085fc3de3ed484b6b7fae.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }